import { render, staticRenderFns } from "./LeadQuiz.vue?vue&type=template&id=4e479de8&scoped=true"
import script from "./LeadQuiz.vue?vue&type=script&lang=js"
export * from "./LeadQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e479de8",
  null
  
)

export default component.exports